import type { CSSProperties } from 'react';
import { cn } from '../ui/cn';

type RefreshIconProps = {
  size?: number;
  color?: string;
  className?: string;
  style?: CSSProperties;
};

/** Іконка оновлення (стрілки по колу), для кнопок retry / reload. */
export default function RefreshIcon({
  size = 18,
  color = 'currentColor',
  className,
  style,
}: RefreshIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('block shrink-0', className)}
      style={style}
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        stroke={color}
        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
      />
    </svg>
  );
}
